import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthContext } from "../../Context/AuthContext";
import { Layout } from "./RoteConfig";
import LangauageVerifier from "../LangauageVerifier";

const PrivateRoute = ({ component: Component }) => {
  const isAuthenticated = useAuthContext();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <Layout>
      <Component />
    </Layout>
  );
};

export default PrivateRoute;
